import { SelectableProduct } from '../components/add-products-modal/add-products-modal.component';

export interface PrioritizedProduct {
  id: string | number;
  priority?: number;
}

// Applies an edit-mode modal result: unticked products are dropped, kept ones retain their own data and order,
// newly ticked ones are appended, and priorities are renumbered.
export function mergeEditedProducts<T extends PrioritizedProduct>(
  currentProducts: T[],
  selectedProducts: SelectableProduct[],
  toNewProduct: (product: SelectableProduct) => T,
  updateKeptProduct: (keptProduct: T, selectedProduct: SelectableProduct) => T = (keptProduct) => keptProduct,
): T[] {
  const selectedById = new Map(selectedProducts.map((product) => [product.id, product]));
  const currentIds = new Set(currentProducts.map((product) => product.id));
  const keptProducts = currentProducts
    .filter((product) => selectedById.has(product.id))
    .map((product) => updateKeptProduct(product, selectedById.get(product.id)));
  const addedProducts = selectedProducts.filter((product) => !currentIds.has(product.id)).map(toNewProduct);
  return [...keptProducts, ...addedProducts].map((product, index) => ({ ...product, priority: index }));
}
